import PaymentManagerContainer from "../../container/admin/payment-manager";

const PaymentManager = () => {
    return <PaymentManagerContainer />;
};

export default PaymentManager;